<template lang="html">
  <div>
    <slot name="breadcrumb" />
    <v-container class="pt-0">
      <v-row>
        <v-col 
          cols="12" 
          md="12"
        >
          <material-card
            :offset="10"
            :full-width="true"
            color="green"
            class="mb-0"
          > 
            <template v-slot:header>
              <v-card-title>
                <div class="px-2">
                  <h4 class="title font-weight-light">
                    {{ branch.branch_name }}
                  </h4>
                  <p class="category font-weight-thin">
                    Viewing {{ branch.branch_name }}
                  </p>
                </div>
                <v-spacer />
                <v-btn  
                  text
                  icon 
                  color="white"
                  @click="dialog = false"
                >
                  <v-icon 
                    v-if="!edit" 
                    @click="edit = true"
                  >
                    edit
                  </v-icon>
                </v-btn>
              </v-card-title>
            </template>

            <v-form 
              v-show="edit"
              ref="form"
            >
              <v-container>
                <v-row>
                  <v-col 
                    cols="12" 
                    md="6"
                  >
                    <v-select
                      v-model="form.company_uid"
                      v-validate="'required'"
                      :error-messages="errors.collect('company_uid')"
                      :items="companies"
                      :disabled="true"
                      data-vv-name="company_uid"
                      data-vv-as="company"
                      item-text="name"
                      item-value="id"
                      label="Company"
                    />
                  </v-col>

                  <v-col 
                    cols="6" 
                    md="4"
                  >
                    <v-autocomplete
                      v-model="form.branch_person_in_charge_uid"
                      v-validate="'required'"
                      :error-messages="errors.collect('branch_person_in_charge_uid')"
                      :disabled="true"
                      :items="users"
                      data-vv-name="branch_person_in_charge_uid"
                      data-vv-as="BIC"
                      item-text="name"
                      item-value="user_uid"
                      label="Branch Incharge (BIC)"
                    />
                  </v-col>

                  <v-col 
                    v-if="this.$hasPermissionTo(['change bic position'])"
                    cols="6" 
                    md="2"
                  >
                    <setup-branch-dialog-bic-edit-index 
                      :branch_uid="branchUid"
                      @refresh-branch="edit=false;getBranchDetails();emitSuccessfulUpdateEvent()"
                    />
                  </v-col>

                  <v-col 
                    cols="12" 
                    md="6"
                  >
                    <v-text-field
                      v-model="form.branch_name"
                      v-validate="'required'"
                      :disabled="this.$hasPermissionTo(['update branches'])?false:true"
                      :error-messages="errors.collect('branch_name')"
                      data-vv-name="branch_name"
                      data-vv-as="Branch Name"                
                      label="Branch Name"
                    />
                  </v-col>

                  <v-col 
                    cols="12" 
                    md="6"
                  >
                    <v-autocomplete
                      v-model="form.om_uid"
                      v-validate="'required'"
                      :disabled="this.$hasPermissionTo(['update branches'])?false:true"
                      :error-messages="errors.collect('om_uid')"
                      :items="omList"
                      data-vv-name="om_uid"
                      data-vv-as="OM Incharge"
                      item-text="name"
                      item-value="user_uid"
                      label="OM Incharge (OM)"
                    />
                  </v-col>

                  <v-col 
                    cols="12" 
                    md="6"
                  >
                    <v-text-field
                      v-model="form.branch_license_no"
                      v-validate="'required'"
                      :disabled="this.$hasPermissionTo(['update branches'])?false:true"
                      :error-messages="errors.collect('branch_license_no')"
                      data-vv-name="branch_license_no"
                      data-vv-as="Branch License Number"
                      label="Branch License Number"
                    />
                  </v-col>

                  <v-col 
                    cols="12" 
                    md="6"
                  >
                    <v-text-field
                      v-model="form.branch_shortcode"
                      v-validate="'required'"
                      :disabled="this.$hasPermissionTo(['update branches'])?false:true"
                      :error-messages="errors.collect('branch_shortcode')"
                      data-vv-name="branch_shortcode"
                      data-vv-as="Branch Shortcode"
                      label="Branch Shortcode"
                    />
                  </v-col>

                  <v-col 
                    cols="12" 
                    md="6"
                  >
                    <v-text-field
                      v-model="form.branch_code"
                      v-validate="'required'"
                      :disabled="this.$hasPermissionTo(['update branches'])?false:true"
                      :error-messages="errors.collect('branch_code')"
                      data-vv-name="branch_code"
                      data-vv-as="Branch Code"
                      label="Branch Code"
                    />
                  </v-col>

                  <v-col 
                    cols="12" 
                    md="6"
                  >
                    <v-text-field
                      v-model="form.old_branch_code"
                      label="Old Branch Code"
                      :disabled="this.$hasPermissionTo(['update branches'])?false:true"
                    />
                  </v-col>
                  <v-col 
                    cols="12" 
                    md="6"
                  >
                    <v-menu
                      id="date"
                      v-model="dateMenu"
                      :close-on-content-click="true"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      :disabled="this.$hasPermissionTo(['update branches'])?false:true"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="branchLicenseExpiryDateDisplay"
                          class="datepicker"
                          label="License Expiry Date"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        />
                      </template>
                      <v-date-picker                  
                        v-model="form.branch_license_expiry_date"                  
                        no-title
                        :disabled="this.$hasPermissionTo(['update branches'])?false:true"
                        @input="startmenu = false"
                      />
                    </v-menu>
                  </v-col>

                  <v-col 
                    cols="12" 
                    md="6"
                  >
                    <v-text-field
                      v-model="form.branch_contact_no"
                      v-validate="'required'"
                      :disabled="this.$hasPermissionTo(['update branches'])?false:true"
                      :error-messages="errors.collect('branch_contact_number')"
                      data-vv-name="branch_contact_number"
                      data-vv-as="Branch Contact Number"
                      label="Branch Contact Number"
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-textarea
                      v-model="form.branch_remarks"
                      solo
                      :disabled="this.$hasPermissionTo(['update branches'])?false:true"
                      name="input-7-4"
                      label="Branch Remarks"
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-row>
                      <v-col
                        cols="6"
                        md="6"
                        class="py-0"
                      >
                        <v-text-field
                          v-model="form.address_line_one"
                          v-validate="'required'"
                          :error-messages="errors.collect('address_line_one')"
                          data-vv-name="address_line_one"
                          data-vv-as="Address 1"
                          label="Address 1"
                        />
                        <v-text-field
                          v-model="form.address_line_two"
                          v-validate="'required'"
                          :error-messages="errors.collect('address_line_two')"
                          data-vv-name="address_line_two"
                          data-vv-as="Address 2"
                          label="Address 2"
                        />
                        <v-text-field
                          v-model="form.address_line_three"
                          label="Address 3"
                        />
                        <v-autocomplete
                          v-model="form.postcode"
                          v-validate="'required'"
                          :value="postCode"
                          :error-messages="errors.collect('postcode')"
                          :items="postcodes"
                          data-vv-name="postcode"
                          data-vv-as="Postcode"
                          item-text="postcode"
                          item-value="postcode"
                          return-object
                          label="Postcode"
                          @input="clearData(); postCodeOnChanged(form.postcode.postcode)"
                        />
                      </v-col>
                      <v-col cols="6">
                        <GmapMap
                          ref="mymap"
                          :center="officeLocation"
                          :zoom="13"
                          map-type-id="roadmap"
                          style="width: 500px; height: 300px"
                          :options="{
                            zoomControl: true,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            rotateControl: false,
                            fullscreenControl: false,
                            disableDefaultUI: false
                          }"
                        >
                          <GmapMarker
                            :position="officeLocation"
                            :clickable="true"
                            :draggable="true"
                            @dragend="getCoordinates($event.latLng)"
                          />
                        </GmapMap>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col 
                    cols="12" 
                    md="6"
                    class="py-0"
                  >
                    <v-autocomplete
                      v-model="branchCity"
                      v-validate="'required'"
                      :items="filteredCities"
                      :error-messages="errors.collect('branch_city')"
                      :disabled="dropdownDisabled"
                      item-text="name"
                      item-value="id"
                      data-vv-name="branch_city" 
                      data-vv-as="City" 
                      label="Branch City"
                      return-object
                      @input="cityOnChanged(branchCity.id)"
                    />
                  </v-col>
                  <v-col 
                    cols="12" 
                    md="6"
                    class="py-0"
                  >
                    <v-autocomplete
                      v-model="branchState"
                      :items="states"
                      item-text="name"
                      return-object
                      label="Branch State"
                      disabled
                    />
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                    class="py-0"
                  >
                    <v-text-field
                      v-model="form.director_name"
                      label="Director Name"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    class="py-0"
                  >
                    <v-text-field
                      v-model="form.director_ic"
                      v-mask="mask"
                      data-vv-name="director_ic"
                      label="Director IC"
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-checkbox
                      v-model="form.branch_is_active"
                      :disabled="this.$hasPermissionTo(['update branches'])?false:true"
                    >
                      <template v-slot:label>
                        <div>
                          Active Branch
                        </div>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>

            <div v-show="!edit">
              <v-overlay :value="loading">
                <v-progress-circular
                  indeterminate
                  size="64"
                />
              </v-overlay>
              <v-container>
                <v-row>
                  <v-col 
                    cols="12"
                    sm="6" 
                    lg="5"
                    xl="4"
                  >
                    <v-icon class="mr-2">
                      mdi-format-title
                    </v-icon>
                    <span class="font-weight-medium">Company:</span>
                  </v-col>
                  <v-col>
                    {{ companyDisplay }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col 
                    cols="4"
                    sm="6" 
                    lg="5"
                    xl="4"
                  >
                    <v-icon class="mr-2">
                      mdi-format-title
                    </v-icon>
                    <span class="font-weight-medium">Branch Name:</span>
                  </v-col>

                  <v-col cols="6">
                    {{ branch.branch_name }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col 
                    cols="12"
                    sm="6" 
                    lg="5"
                    xl="4"
                  >
                    <v-icon class="mr-2">
                      mdi-account
                    </v-icon>
                    <span class="font-weight-medium">Branch Incharge:</span>
                  </v-col>
                  <v-col>
                    {{ bicDisplay }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col 
                    cols="12"
                    sm="6" 
                    lg="5"
                    xl="4"
                  >
                    <v-icon class="mr-2">
                      mdi-account-star
                    </v-icon>
                    <span class="font-weight-medium">Operations Manager:</span>
                  </v-col>

                  <v-col>
                    {{ omDisplay }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col 
                    cols="12"
                    sm="6" 
                    lg="5"
                    xl="4"
                  >
                    <v-icon class="mr-2">
                      mdi-format-title
                    </v-icon>
                    <span class="font-weight-medium">Branch License Number:</span>
                  </v-col>

                  <v-col>
                    {{ branch.branch_license_no }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col 
                    cols="12"
                    sm="6" 
                    lg="5"
                    xl="4"
                  >
                    <v-icon class="mr-2">
                      code
                    </v-icon>
                    <span class="font-weight-medium">Branch Shortcode:</span>
                  </v-col>

                  <v-col>
                    {{ branch.branch_shortcode }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col 
                    cols="12"
                    sm="6" 
                    lg="5"
                    xl="4"
                  >
                    <v-icon class="mr-2">
                      code
                    </v-icon>
                    <span class="font-weight-medium">Branch Code:</span>
                  </v-col>

                  <v-col>
                    {{ branch.branch_code }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col 
                    cols="12"
                    sm="6" 
                    lg="5"
                    xl="4"
                  >
                    <v-icon class="mr-2">
                      code
                    </v-icon>
                    <span class="font-weight-medium">Old Branch Code:</span>
                  </v-col>

                  <v-col>
                    {{ branch.old_branch_code }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col 
                    cols="12"
                    sm="6" 
                    lg="5"
                    xl="4"
                  >
                    <v-icon class="mr-2">
                      date_range
                    </v-icon>
                    <span class="font-weight-medium">License Expiry Date:</span>
                  </v-col>

                  <v-col>
                    {{ branchLicenseExpiryDateDisplay }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col 
                    cols="12"
                    sm="6" 
                    lg="5"
                    xl="4"
                  >
                    <v-icon class="mr-2">
                      mdi-phone
                    </v-icon>
                    <span class="font-weight-medium">Branch Contact Number:</span>
                  </v-col>

                  <v-col>
                    {{ branch.branch_contact_no }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col 
                    cols="12"
                    sm="6" 
                    lg="5"
                    xl="4"
                  >
                    <v-icon class="mr-2">
                      mdi-google-maps
                    </v-icon>
                    <span class="font-weight-medium">Branch Address:</span>
                  </v-col>

                  <v-col 
                    sm="6" 
                    xl="8"
                  >
                    {{ branch.address_line_one+', '+ (branch.address_line_two? branch.address_line_two+', ': '') + (branch.address_line_three? branch.address_line_three+', ': ' ') + branch.postcode +', ' + branch.branch_city + ', '+ stateDisplay }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col 
                    cols="12"
                    sm="6" 
                    lg="5"
                    xl="4"
                  >
                    <v-icon class="mr-2">
                      mdi-comment
                    </v-icon>
                    <span class="font-weight-medium">Branch Remarks:</span>
                  </v-col>
                  <v-col 
                    sm="6" 
                    xl="8"
                  >
                    {{ branch.branch_remarks }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col 
                    cols="12"
                    sm="6" 
                    lg="5"
                    xl="4"
                  >
                    <v-icon class="mr-2">
                      map
                    </v-icon>
                    <span class="font-weight-medium">Branch State:</span>
                  </v-col>
                  <v-col 
                    sm="6" 
                    xl="8"
                  >
                    {{ stateDisplay }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col 
                    cols="12"
                    sm="6" 
                    lg="5"
                    xl="4"
                  >
                    <v-icon class="mr-2">
                      map
                    </v-icon>
                    <span class="font-weight-medium">Branch City:</span>
                  </v-col>

                  <v-col 
                    sm="6" 
                    xl="8"
                  >
                    {{ cityDisplay }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col 
                    cols="12"
                    sm="6" 
                    lg="5"
                    xl="4"
                  >
                    <v-icon class="mr-2">
                      mdi-account
                    </v-icon>
                    <span class="font-weight-medium">Director Name:</span>
                  </v-col>

                  <v-col 
                    sm="6" 
                    xl="8"
                  >
                    {{ branch.director_name }}
                  </v-col>
                </v-row>

                <v-row>
                  <v-col 
                    cols="12"
                    sm="6" 
                    lg="5"
                    xl="4"
                  >
                    <v-icon class="mr-2">
                      mdi-credit-card
                    </v-icon>
                    <span class="font-weight-medium">Director IC:</span>
                  </v-col>

                  <v-col 
                    sm="6" 
                    xl="8"
                  >
                    {{ branch.director_ic }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col 
                    cols="12"
                    sm="6" 
                    lg="5"
                    xl="4"
                  >
                    <v-icon class="mr-2">
                      mdi-alert
                    </v-icon>
                    <span class="font-weight-medium">Branch Status:</span>
                  </v-col>

                  <v-col>
                    <span :class=" branch.branch_is_active === 1 ? 'text-success font-weight-bold':'text-danger font-weight-bold'">
                      {{ branch.branch_is_active === 1 ? "Active" : "Inactive" }}

                    </span>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col 
                    cols="12"
                    sm="6" 
                    lg="5"
                    xl="4"
                  >
                    <v-icon class="mr-2">
                      mdi-map-marker
                    </v-icon>
                    <span class="font-weight-medium">Location:</span>
                  </v-col>
                  <v-col>
                    <GmapMap
                      :center="{lat:Number((branch.office_location ||{}).latitude ||0 ),lng:Number((branch.office_location ||{}).longitude ||0)}"
                      :zoom="13"
                      map-type-id="roadmap"
                      style="width: 500px; height: 300px"
                      :options="{
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: false,
                        streetViewControl: false,
                        rotateControl: false,
                        fullscreenControl: false,
                        disableDefaultUI: false
                      }"
                    >
                      <GmapMarker
                        :position="{lat:Number((branch.office_location ||{}).latitude ||0),lng:Number((branch.office_location ||{}).longitude||0 )}"
                      />
                    </GmapMap>
                  </v-col>
                </v-row>
              </v-container>
            </div>
      
            <v-card-actions v-if="this.$hasPermissionTo(['update branches'])">
              <v-spacer />
              <div>
                <v-btn
                  v-if="edit"
                  :disabled="progressing"
                  text
                  @click="edit = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  v-if="edit"
                  :loading="progressing"
                  class="mx-2 font-weight-light"
                  color="success"          
                  @click="submitForm"
                >
                  Save Changes
                </v-btn>
              </div>
            </v-card-actions>
          </material-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      SetupBranchDialogBicEditIndex: () => import('@/components/setup/branch/DialogBicEditIndex'),
    },
    props: {
      branchUid: {
        type: String,
        default: null,
      },
    },
    data () {
      return {
        edit: false,
        loading: false,
        progressing: false,
        companies: [],
        users: [],
        states: [],
        cities: [],
        postcodes: [],
        dateMenu: false,
        form: {
          branch_person_in_charge_uid: '',
          om_uid: '',
          company_uid: '',
          branch_name: '',
          branch_shortcode: '',
          branch_code: '',
          branch_contact_no: '',
          branch_license_no: '',
          branch_remarks: '',
          branch_is_active: 0,
          branch_state: '',
          branch_city: '',
          address_line_one: '',
          address_line_two: '',
          address_line_three: '',
          postcode: '',
          director_ic: '',
          director_name: '',
          old_branch_code: '',
          branch_license_expiry_date: null,
        },
        mask: '######-##-####',
        branchCity: {},
        branchState: {},
        dropdownDisabled: null,
        cityIds: [],
      }
    },
    computed: {
      changeOfAddress () {
        if (!this.edit) return false
        if (this.branch.postcode !== this.form.postcode) return true
        return false
      },
      officeLocation () {
        if (!this.form.office_location) return { lat: 0, lng: 0 }
        return {
          lat: Number((this.form.office_location || {}).latitude || 0),
          lng: Number((this.form.office_location || {}).longitude || 0),
        }
      },
      branchLicenseExpiryDateDisplay () {
        if (this.form.branch_license_expiry_date == null) {
          return ''
        }

        return this.$moment(this.form.branch_license_expiry_date, 'YYYY/MM/DD').format('D MMM YYYY')
      },
      bicDisplay () {
        return (this.users.find(user => {
          return user.user_uid === this.branch.branch_person_in_charge_uid
        }) || {}).name || ''
      },
      cityDisplay () {
        if (!this.branch.branch_city) return
        return (this.cities.find(city => {
          return (city.name).toUpperCase() === (this.branch.branch_city).toUpperCase()
        }) || {}).name || ''
      },
      postCode () {
        if (!this.form.postcode) return
        return this.postcodes.find(postcode => {
          return postcode.postcode === (typeof (this.form.postcode.postcode) === 'undefined' ? this.form.postcode : (this.form.postcode.postcode ? this.form.postcode.postcode : this.form.postcode))
        })
      },
      filteredCities () {
        return this.cities.filter(city => {
          return this.cityIds.includes(city.id)
        })         
      },
      companyDisplay () {
        return (this.companies.find(company => {
          return company.id === this.branch.company_uid
        }) || {}).name || ''
      },
      omDisplay () {
        return (this.users.find(user => {
          return user.user_uid === this.branch.om_uid
        }) || {}).name || ''
      },
      stateDisplay () {
        return (this.states.find(state => {
          return state.code === this.branch.branch_state
        }) || {}).name || ''
      },
      omList () {
        return this.users.filter((user) => {
          let found = false
          if (user.crm_roles) {
            user.crm_roles.forEach((role) => {
              if (role.id === 37) {
                found = true
              }
            })
          }

          return found
        })
      },
      ...mapGetters({
        branch: 'branch/currentBranch',
      }),
    
    },
    watch: {
      branchUid: {
        handler (oldValue, newValue) {
          if (newValue || (oldValue !== newValue)) {
            this.getBranchDetails()
            this.edit = false
          }
        },
      },
      changeOfAddress (val) {
        if (val) {
          this.getCoordinatesFromAddress()
        }
      },
    },
    inject: ['$validator'],
    mounted () {
      Promise.all([
        this.$api.companies().list(),
        this.$api.users().list('?with=crmrole'),
        this.$api.cities().list(),
        this.$api.states().list(),
        this.$api.postcodes().list(),
      ])
        .then(([companies, users, cities, states, postcodes]) => {
          this.companies = companies.data
          this.users = users.data
          this.cities = cities.data
          this.states = states.data
          this.postcodes = postcodes.data
        })
    },
    methods: {
      clearData () {
        this.branchCity = null
        this.branchState = null
      },
      postCodeOnChanged (postcodeValue) {
        var cityID = this.postcodes.filter(p => {
          return p.postcode === postcodeValue
        })  

        this.cityIds = this.cities.filter(city => {
          return cityID.some(city2 => {
            return city2.city_id === city.id
          })
        }).map(city3 => {
          return city3.id
        })

        if (this.cityIds.length > 1) {
          this.dropdownDisabled = false
        } else {
          this.dropdownDisabled = true

          var cityId = this.postcodes.find(postcode => {
            return postcode.postcode === postcodeValue
          }).city_id

          if (cityId) {
            var cityObject = this.cities.find(city => {
              return city.id === cityId
            })
            this.branchCity = cityObject

            if (cityObject) {
              var stateObject = this.states.find(state => {
                return state.id === cityObject.state_id
              })
              this.branchState = stateObject
            }
          }          
        }
      },
      cityOnChanged (cityId) {
        var cityObj = this.cities.find(city => {
          return city.id === cityId
        })

        if (cityObj) {
          var stateObj = this.states.find(state => {
            return state.id === cityObj.state_id
          })
          this.branchState = stateObj
        }
      },
      getCoordinates (location) {
        this.form.office_location.latitude = location.lat()
        this.form.office_location.longitude = location.lng()
      },
      getBranchDetails () {
        this.loading = true
        this.setProgressing(true)
        this.$store.dispatch('branch/getCurrentBranch', this.branchUid)
          .then(() => {
            this.form = JSON.parse(JSON.stringify(this.branch))
            this.form.branch_is_active = this.form.branch_is_active !== 0
            // this.form.branch_license_expiry_date = new Date().toISOString().substr(0, 10)
            this.postCodeOnChanged(this.form.postcode)
            this.branchCity = this.cities.find(city => {
              return (city.name).toUpperCase() === (this.form.branch_city).toUpperCase()
            })
            this.branchState = this.states.find(state => {
              return state.id === this.branchCity.state_id
            })
            this.getStateCities()
            this.setProgressing(false)
            this.loading = false
            this.$validator.reset()
          })
      },
      getStateCities () {
        this.form.branch_state = this.states.find(state => {
          return state.code === this.form.branch_state
        })
      },
      prepareFormData () {
        let form = JSON.parse(JSON.stringify(this.form))

        return {
          company_uid: form.company_uid,
          branch_person_in_charge_uid: form.branch_person_in_charge_uid,
          om_uid: form.om_uid,
          branch_name: form.branch_name,
          branch_shortcode: form.branch_shortcode,
          branch_code: form.branch_code,
          old_branch_code: form.old_branch_code,
          branch_contact_no: form.branch_contact_no,
          branch_license_no: form.branch_license_no,
          branch_license_expiry_date: form.branch_license_expiry_date,
          branch_remarks: form.branch_remarks,
          branch_is_active: form.branch_is_active === true ? 1 : 0,
          address_line_one: this.checkStringHasComma(form.address_line_one),
          address_line_two: this.checkStringHasComma(form.address_line_two),
          address_line_three: this.checkStringHasComma(form.address_line_three),
          postcode: this.postCode.postcode,
          branch_city: this.branchCity.name,
          branch_state: this.branchState.code,
          longitude: (form.office_location || {}).longitude,
          latitude: (form.office_location || {}).latitude,
          director_name: form.director_name,
          director_ic: form.director_ic,
        }
      },
      setProgressing (value = false) {
        this.progressing = value
      },
      emitSuccessfulUpdateEvent () {
        this.$emit('updated')
      },
      submitForm () {
        this.validateForm().then((result) => {
          if (result) {          
            this.setProgressing(true)

            this.$api.branches().update(this.branchUid, this.prepareFormData())
              .then((res) => {
                if (res.status >= 200 && res.status < 300) {
                  this.$snack({
                    message: 'Branch updated',
                  })

                  this.edit = false
                  this.getBranchDetails()
                  this.emitSuccessfulUpdateEvent()
                }
              })
              .catch(() => {})
              .then(() => {
                this.setProgressing(false)
              })
          } else {
            this.$scrollToFirstErrorInput()
          }
        })  
      },
      validateForm () {
        return this.$validator.validateAll()
      },
      checkStringHasComma (string) {
        if (string) {
          if (string.charAt(string.length - 1) === ',') {
            return string.substring(0, string.length - 1)
          }
        }
        return string
      },
      getCoordinatesFromAddress () {
        let axios3 = axios.create()

        delete axios3.defaults.headers.common['Authorization']
        axios3.post('https://maps.googleapis.com/maps/api/geocode/json?address=' + this.constructAddress() + '&key=AIzaSyAkKNcrjO7LVSERlART5ZwZQCpukTY5UBI')
          .then(res => {
            if (res.data.status === 'OK') {
              res.data.results.map(data => {
                this.form.office_location.latitude = data.geometry.location.lat
                this.form.office_location.longitude = data.geometry.location.lng
              })
            } else {
              this.$snack({ 
                color: 'error',
                message: 'GPS coordinate not found. Please mark the correct location', 
              })
            }
          })
      },

      constructAddress () {
        return this.checkStringHasComma(this.form.address_line_one) + ', ' +
          (this.form.address_line_two ? this.checkStringHasComma(this.form.address_line_two) + ', ' : '') +
          (this.form.address_line_three ? this.checkStringHasComma(this.form.address_line_three) + ', ' : '') + this.branchCity.name + ', ' + this.branchState.name
      },
    },
  }
</script>

<style lang='css' scoped>
  .datepicker .v-btn{
      padding:0 !important;
      border-radius: 50%!important;; 
  }
</style>
